export default {
  items: [

    {
      name: 'About Us',
      url: '',
      icon: 'info',
      childs: [
        {
          name: 'Our Story',
          url: '/about-us/background#background',
          icon: 'assignment'
        },
        {
          name: 'Our Vision',
          url: '/about-us/background#vision',
          icon: 'assignment'
        },
        {
          name: 'Franchising',
          url: '/franchise',
          icon: 'poll'
        },
        {
          name: 'Store Locator',
          url: '/outlets',
          icon: 'map-marker',
          childs: []
        },
        {name: 'Our Contact', url: 'https://wa.me/6281382539679'}
      ]
    },
    {
      name: 'What\'s New',
      url: '',
      icon: 'grade',
      childs: [
        {
          name: 'Hall',
          url: '/news/hall',
          icon: 'public'
        },
        {
          name: 'Promotion',
          url: '/news/promotion',
          icon: 'card_membership'
        },
        {
          name: 'News',
          url: '/news/feed',
          icon: 'grade'
        }
      ]
    },
    {
      name: 'Gallery',
      url: '',
      icon: 'monochrome_photos',
      childs: [
        {
          name: 'Menu',
          url: '/gallery/menu',
          icon: 'menu'
        },
        {
          name: 'Video',
          url: '/gallery/video',
          icon: 'video_library'
        }
      ]
    },
    {
      name: 'Shops',
      url: '/shops',
      icon: 'shopping_cart'
    },
    // {
    //   name: 'Traceability',
    //   url: '',
    //   icon: 'link',
    //   childs: [
    //     {
    //       name: 'Farm To GreenBean',
    //       url: '/traceability#Farm To GreenBean',
    //       icon: 'link'
    //     },
    //     {
    //       name: 'Farm To Roaster',
    //       url: '/traceability#Farm To Roaster',
    //       icon: 'link'
    //     },
    //     {
    //       name: 'Farm To Cup',
    //       url: '/traceability#Farm To Cup',
    //       icon: 'link'
    //     }
    //   ]
    // },
    {
      name: 'Apps',
      url: '/apps',
      icon: 'apps'
    }
  ],
  shortcuts: [
    {
      name: 'About Us',
      childs: [
        {name: 'Our Story', url: '/#/about-us/background#background'},
        {name: 'Our Vision', url: '/#/about-us/background#vision'},
        {name: 'Franchising', url: '/#/franchise'},
        {name: 'Store Locator', url: '/#/outlets'},
        {name: 'Our Contact', url: 'https://wa.me/6281382539679'}
      ]
    },
    {
      name: 'What\'s New',
      childs: [
        {name: 'Promotions', url: '/#/news/promotion'},
        {name: 'News', url: '/#/news/feed'}
      ]
    },
    {
      name: 'Gallery',
      childs: [
        {name: 'Menu', url: '/#/gallery/menu'},
        {name: 'Video', url: '/#/gallery/video'}
      ]
    },
    {
      name: 'Shops',
      childs: [
        {name: 'Bean', url: '/#/shops'},
        {name: 'Equipment', url: '/#/shops'},
        {name: 'Merchandise', url: '/#/shops'},
        {name: 'Coffee Gift', url: '/#/shops'}
      ]
    },
    {
      name: 'Press',
      childs: [
        {name: 'Instagram', url: 'https://www.instagram.com/kopiketjil/'},
        {name: 'Facebook', url: 'https://www.facebook.com/Kopiketjilofficial/'}
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js